export const CursorDirections = {
    forward: 'forward',
    backward: 'backward',
};
export const SortDirections = {
    asc: 'asc',
    desc: 'desc',
};
export function applyCursor(base, input) {
    let q = base;
    if (input.cursor) {
        q = q.start({ id: input.cursor.id, createdAt: input.cursor.createdAt });
    }
    if (input.limit) {
        q = q.limit(input.limit);
    }
    const way = input.cursor?.direction || 'forward';
    const sortField = input.sort?.field || 'createdAt';
    const sortDir = input.sort?.dir || 'desc';
    const direction = way === 'forward' ? sortDir : sortDir === 'asc' ? 'desc' : 'asc';
    q = q.orderBy(sortField, direction).orderBy('id', direction);
    return q;
}
//# sourceMappingURL=apply-cursor.js.map